import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { LocalizationHelperInstance, ServiceHelper } from "utils/helpers";
import useAPIClientHelper from "./useAPIClientHelper";
import { AuthEnums } from "models/enums";
import { ServiceConstants } from "utils/constants";

function useReceiptPaymentMethodService() {
  const { apiClientInstance } = useAPIClientHelper();

  const get = (paymentMethodId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company).ReceiptPaymentMethodClient.GetByPaymentmethodid(
      paymentMethodId
    );
  };

  const getAll = () => {
    return ServiceHelper.getAllPages((page) =>
      apiClientInstance(AuthEnums.AuthType.Company).ReceiptPaymentMethodClient.GetByFilter({
        ...ServiceConstants.DefaultFilter,
        orderByProperty: "Name",
        page: page,
        includeAllEmployees: false,
        includeCompanyIdForWintCards: true,
      })
    );
  };

  const post = (receiptPaymentMethod: ApiModels.ReceiptPaymentMethodPost) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .ReceiptPaymentMethodClient.Post(receiptPaymentMethod as ApiModels.ReceiptPaymentMethodPost)
      .then((res) => res.data);
  };

  const update = (id: number, receiptPaymentMethod: ApiModels.ReceiptPaymentMethodPut) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).ReceiptPaymentMethodClient.Update(id, receiptPaymentMethod);
  };

  const getTopPaymentMethods = (count?: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .ReceiptPaymentMethodClient.GetTopPaymentMethods(count)
      .then((res) => res.data?.filter((d) => !d.isPaymentMethodTypeDisabled));
  };

  const getTypeText = (type?: ApiModels.ReceiptPaymentMethodType) => {
    return type !== undefined
      ? LocalizationHelperInstance.getFormattedMessage(`Receipt.PaymentMethodType_${type}`)
      : "-";
  };

  const canEdit = (paymentMethodType?: ApiModels.ReceiptPaymentMethodType, canDeactivate?: boolean) =>
    !!canDeactivate && paymentMethodType === ApiModels.ReceiptPaymentMethodType.OwnExpense;

  return { get, getAll, post, update, getTopPaymentMethods, getTypeText, canEdit };
}

export default useReceiptPaymentMethodService;
